import request from '@/utils/request' // 引入封装的request.js文件

// 获取下载记录列表
export function getDownloadList(query) {
  return request({
    url: '/download/record/lists',
    method: 'get',
    params: query
  })
}

// 保存下载记录
export function saveDownloadLog(data) {
  return request({
    url: '/download/record/insert',
    method: 'post',
    data
  })
}

// 下载申请
export function downloadApply(data) {
  return request({
    url: '/download/apply/insert',
    method: 'post',
    data
  })
}

// 下载文件
export function downloadGet(query) {
  return request({
    url: '/common/download',
    method: 'get',
    params: query
  })
}